import { useLocation, useNavigate } from 'react-router-dom';
import BannerLogo from '../../components/BannerLogo/BannerLogo';
import BotonGrandeDinamico from '../../components/Botones/BotonGrandeDinamico/BotonGrandeDinamico';
import Footer from '../../components/Footer/Footer';
import { ROUTES } from '../../const/routes';
import { useUser } from '../../context/UserContext';
import styles from './NotFound.module.css';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useUser();
  const { t } = useTranslation();

  const rutaSugerida = userData ? ROUTES.listaJuegos : ROUTES.inicio;
  const textoSugerido = userData ? t('notFound.gamesButton') : t('notFound.homeButton');

  return (
    <div className={'flex min-h-screen flex-col ' + styles.notFoundContainer}>
      <div className="relative flex flex-1 flex-col items-center justify-between overflow-hidden px-4 pb-8 pt-2 text-center">
        <div className="relative z-10 flex w-full max-w-6xl flex-1 flex-col items-center justify-between">
          <BannerLogo />

          <section
            className={`${styles.panel404} bg-bgContenedorOscuro border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro`}
          >
            <div className={styles.badge}>{t('notFound.badge')}</div>
            <div className={styles.titleWrap}>
              <p className={styles.kicker}>{t('notFound.kicker')}</p>
              <h1 className={styles.title}>
                {t('notFound.title')}
              </h1>
            </div>

            <p className={styles.description}>
              {t('notFound.description')}
            </p>

            <div className={styles.pathBox}>
              <span className={styles.pathLabel}>{t('notFound.requestedRoute')}</span>
              <span className={styles.pathValue}>{location.pathname}</span>
            </div>

            <div className={styles.actions}>
              <BotonGrandeDinamico
                texto={textoSugerido}
                bgColor="blue"
                direccion={rutaSugerida}
              />
              <BotonGrandeDinamico
                texto={userData ? t('notFound.profileButton') : t('login.title')}
                bgColor="pink"
                direccion={userData ? ROUTES.perfil : ROUTES.login}
              />
              <BotonGrandeDinamico
                texto={t('notFound.homeButton')}
                bgColor="orange"
                funcion={() => navigate(-1)}
              />
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NotFound;
